import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import api from "../services/api";
import {
  setAllCohorts,
  addToAllCohorts,
  addMenuIfNotExists
} from "../features/cohort/cohortSlice";

import "../styles/cohort.css";

export default function Cohort() {
  const { trace_id } = useParams(); // IMPORTANT
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const allCohorts = useSelector(state => state.cohort.all);

  const messages = trace_id
    ? allCohorts
        .filter(c => c.trace_id === trace_id)
        .sort(
          (a, b) =>
            new Date(a.created_at) - new Date(b.created_at)
        )
    : [];

  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);

  // store details per segment_id
  const [details, setDetails] = useState({});
  const [openDetails, setOpenDetails] = useState({});

  const [selectedSegment, setSelectedSegment] = useState(null);


  // SEND PROMPT
  const sendPrompt = async () => {
    if (!input.trim() || loading) return;

    try {
      setLoading(true);

      const res = await api.post(
        "https://aihealth.ascendeongroup.com/api-dev/v1/business/cohorts/preview/new",
        null,
        {
          params: {
            prompt: input,
            ...(trace_id ? { chat_id: trace_id } : {})
          },
          headers: { accept: "application/json" }
        }
      );

      const payload = {
        ...res.data,
        prompt: input
      };

      // add to chat
      dispatch(addToAllCohorts(payload));

      // update menu if new chat
      dispatch(
        addMenuIfNotExists({
          trace_id: res.data.trace_id,
          cohort_name: res.data.cohort_name,
          created_at: res.data.created_at
        })
      );

      setInput("");

      // navigate on first message
      if (!trace_id) {
        navigate(`/cohort/${res.data.trace_id}`, {
          replace: true
        });
      }

    } catch (err) {
      console.error("Preview failed", err);
    } finally {
      setLoading(false);
    }
  };

  // VIEW DETAILS
  const viewDetails = async (segment_id) => {
    try {
      if (!details[segment_id]) {
        const res = await api.get(
          `https://aihealth.ascendeongroup.com/api-dev/v1/business/cohorts/${segment_id}/new`,
          { headers: { accept: "application/json" } }
        );

        setDetails(prev => ({
          ...prev,
          [segment_id]: res.data
        }));

        setSelectedSegment(res.data);
      } else {
        setSelectedSegment(details[segment_id]);
      }
    } catch (err) {
      console.error("Details fetch failed", err);
    }
  };


  const deleteSegment = async (segment_id) => {
    if (!window.confirm("Delete this cohort segment?")) return;

    try {
      const res = await api.post(
        `https://aihealth.ascendeongroup.com/api-dev/v1/admin/segments/${segment_id}/delete`,
        null,
        { headers: { accept: "application/json" } }
      );

      if (res.data?.status === "DELETED") {
        // remove from redux + localStorage
        const updated = allCohorts.filter(
          c => c.segment_id !== segment_id
        );

        dispatch(setAllCohorts(updated)); // ⚠️ see note below
      }
    } catch (err) {
      console.error("Delete failed", err);
    }
  };



  const formatDate = (dateStr) =>
    new Date(dateStr).toLocaleString();

  return (
    <div className="cohort-page">
      <div className="chat-window">

        {messages.map((msg, idx) => (
          <div key={idx}>
            {/* USER PROMPT */}
            <div className="chat-bubble user" style={{ position: "relative" }}>
              {msg.prompt_text}

              <i
                className="fa-solid fa-trash"
                title="Delete"
                onClick={() => deleteSegment(msg.segment_id)}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                  opacity: 0.7
                }}
              />
            </div>
            


            {/* SYSTEM RESPONSE */}
            <div className="chat-bubble system">
              {/* PROMPT TEXT */}
              {msg.cohort_name && (
                <div className="prompt-box">
                  <span className="prompt-label"><strong>Name:</strong></span>
                  <span className="prompt-text">{msg.cohort_name}</span>
                </div>
              )}


              <div>
                <strong>Count:</strong> {msg.preview_count?.preview_count ? msg.preview_count?.preview_count : msg.preview_count}
              </div>

              <div
                className="link"
                onClick={() => viewDetails(msg.segment_id)}
              >
                View details
              </div>




              {/* DETAILS */}
              {/* {openDetails[msg.segment_id] && (
                details[msg.segment_id] && (() => {
                  const sqlRaw = details[msg.segment_id].sql_used;
                  let firstSql = "";

                  try {
                    const parsed = JSON.parse(sqlRaw);
                    firstSql = parsed?.[0]?.[0] || "";
                  } catch (e) {
                    firstSql = "";
                  }

                  return (
                    <div className="details-box">
                      <div>
                        <strong>Status:</strong>{" "}
                        {details[msg.segment_id].status}
                      </div>

                      <div>
                        <strong>Created At:</strong>{" "}
                        {formatDate(details[msg.segment_id].created_at)}
                      </div>

                      <div>
                        <strong>Preview Count:</strong>{" "}
                        {details[msg.segment_id].preview_count}
                      </div>

                      <div>
                        <strong>SQL Used:</strong>
                        <pre style={{ whiteSpace: "pre-wrap" }}>
                          {firstSql}
                        </pre>
                      </div>
                    </div>
                  );
                })()
              )} */}
            </div>
          </div>
        ))}

      </div>

      {/* INPUT */}
      <div className="chat-input">
        <textarea
          rows="3"
          placeholder="Describe your cohort..."
          value={input}
          onChange={e => setInput(e.target.value)}
          disabled={loading}
        />

        <button
          onClick={sendPrompt}
          disabled={loading}
        >
          {loading ? "Sending..." : "Send"}
        </button>
      </div>

      {selectedSegment && (() => {
        let sqlList = [];

        try {
          sqlList = JSON.parse(selectedSegment.sql_used || "[]");
        } catch (e) {
          sqlList = [];
        }

        return (
          <div className="modal-overlay">
            <div className="modal-box">
              <div className="modal-header">
                <h3>{selectedSegment.cohort_name}</h3>
                <button
                  style={{margin: "0"}}
                  className="modal-close"
                  onClick={() => setSelectedSegment(null)}
                >
                  ✕
                </button>
              </div>


              <div><strong>Status:</strong> {selectedSegment.status}</div>
              <div><strong>Created At:</strong> {formatDate(selectedSegment.created_at)}</div>
              <div><strong>Count:</strong> {selectedSegment.preview_count?.preview_count}</div>

              <h4>State Distribution</h4>
              {(() => {
                const list = selectedSegment.preview_count?.state_distribution || [];
                const columnCount = 3; // change to 4 if you want
                const perColumn = Math.ceil(list.length / columnCount);

                const columns = Array.from({ length: columnCount }, (_, i) =>
                  list.slice(i * perColumn, (i + 1) * perColumn)
                );

                return (
                  <div className="distribution-grid">
                    {columns.map((col, colIndex) => (
                      <div key={colIndex}>
                        {col.map((item, i) => (
                          <div key={i}>
                            {item.zip3} — {item.member_count}
                          </div>
                        ))}
                      </div>
                    ))}
                  </div>
                );
              })()}


              <h4>Age Distribution</h4>
              {selectedSegment.preview_count?.age_distribution?.map((a, i) => (
                <div key={i}>
                  {a.age_group} — {a.member_count}
                </div>
              ))}

              {(() => {
                let sqlList = [];

                try {
                  sqlList = JSON.parse(selectedSegment.sql_used || "[]");
                } catch (e) {
                  sqlList = [];
                }

                return (
                  <>
                    {sqlList[0] && (
                      <>
                        <h4>SQL Used</h4>
                        <pre style={{ whiteSpace: "pre-wrap" }}>
                          {sqlList[0]}
                        </pre>
                      </>
                    )}

                    {sqlList[1] && (
                      <>
                        <h4>Zip Distribution SQL</h4>
                        <pre style={{ whiteSpace: "pre-wrap" }}>
                          {sqlList[1]}
                        </pre>
                      </>
                    )}

                    {sqlList[2] && (
                      <>
                        <h4>Age Distribution SQL</h4>
                        <pre style={{ whiteSpace: "pre-wrap" }}>
                          {sqlList[2]}
                        </pre>
                      </>
                    )}
                  </>
                );
              })()}



              <button onClick={() => setSelectedSegment(null)}>
                Close
              </button>
            </div>
          </div>
        );
      })()}

    </div>
    
  );
}
